// internal-deps
import { UserAddress } from "@swiggy-private/cart-types";
import { ADDRESS_CATEGORIES } from "@swiggy-private/core-types";
import { isPopFlow } from "@swiggy-private/checkout-core";
import { format, isEmpty } from "@swiggy-private/js-utils";
// constants
import { TEXTS } from "@cart-ui/constants";

export const getHeaderAddressAnnotationText = (
    selectedAddress?: UserAddress | null,
    category?: number,
): string => {
    const slaMessage = selectedAddress?.sla_message;
    let deliveryAnnotation = "";
    switch (category) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            deliveryAnnotation = TEXTS.HOME;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            deliveryAnnotation = TEXTS.WORK;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            deliveryAnnotation = selectedAddress?.name || TEXTS.HOME;
            break;
        default:
            deliveryAnnotation = selectedAddress?.annotation || TEXTS.OTHER;
            break;
    }
    if (isPopFlow() && !isEmpty(slaMessage)) {
        return format(TEXTS.SLA_TO_ANNOTATION, slaMessage, deliveryAnnotation);
    }

    return deliveryAnnotation ?? "";
};

export const mapAddressCategoryToAddressType = (addressCategory: number): string => {
    switch (addressCategory) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            return "Home";
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            return "Work";
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            return "FnF";
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_OTHER:
            return "Other";
        default:
            return "Invalid";
    }
};
